import { render, staticRenderFns } from "./ResumationDualList.vue?vue&type=template&id=1872b043&"
import script from "./ResumationDualList.vue?vue&type=script&lang=js&"
export * from "./ResumationDualList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports